import { useConsultDoctorContext } from "../../Contexts/ConsultDoctorContext";
import { MenuItem, Select } from "@mui/material";
import PropTypes from "prop-types";

function SelectSpecialization(props) {

	const {
		setSelectedSpecialization,
		setAllDoctorsFromBranch,
		selectedSpecialization,
		specializationsData,
		setSelectedDate,
		setDoctorsData,
	} = useConsultDoctorContext();

	const { hasAllOption } = props;

	const handleChangeSpecialization = (e) => {
		const selectedId = e.target.value;
		const selectedObject = specializationsData.find(
			(spec) => spec.id === selectedId
		);
		setSelectedSpecialization(selectedObject);
		setSelectedDate(null);
		setDoctorsData([]); // Ensure this function updates according to the selected specialization.
    	setAllDoctorsFromBranch([]);
	};

	let allOption = null;
	if (hasAllOption) {
		allOption = <MenuItem value={undefined}>All</MenuItem>;
	}

	return (
		<div className="mb-2">
			<p className="text-sm mb-1 font-semibold">Select Specialization</p>
			<Select
				className="w-full h-10"
				value={selectedSpecialization?.id}
				onChange={(e) => handleChangeSpecialization(e)}
			>
				{allOption}
				{specializationsData?.map((data) => (
					<MenuItem value={data.id} key={data.id}>
						{data.name.substring(data.name.indexOf(":") + 1)}
					</MenuItem>
				))}
			</Select>
		</div>
	);
}

SelectSpecialization.propTypes = {
	hasAllOption: PropTypes.bool
};

export default SelectSpecialization;